module.exports = __webpack_public_path__ + "static/img/haike-qrcode.f77e03ff.png";